// API service for deal stats (views, likes, ratings)

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const dealStatsApi = {
  // Get stats for a specific deal
  getStats: async (dealId) => {
    try {
      const response = await fetch(`${API_URL}/api/deals/${dealId}/stats`);
      if (!response.ok) throw new Error('Failed to fetch stats');
      return await response.json();
    } catch (error) {
      console.error('Error fetching deal stats:', error);
      return null;
    }
  },

  // Increment view count
  incrementView: async (dealId) => {
    try {
      const response = await fetch(`${API_URL}/api/deals/${dealId}/view`, {
        method: 'POST',
      });
      if (!response.ok) throw new Error('Failed to increment view');
      return await response.json();
    } catch (error) {
      console.error('Error incrementing view:', error);
      return null;
    }
  },

  // Like a deal
  likeDeal: async (dealId) => {
    try {
      const response = await fetch(`${API_URL}/api/deals/${dealId}/like`, {
        method: 'POST',
      });
      if (!response.ok) throw new Error('Failed to like deal');
      return await response.json();
    } catch (error) {
      console.error('Error liking deal:', error);
      return null;
    }
  },

  // Rate a deal (1-5 stars)
  rateDeal: async (dealId, rating) => {
    try {
      const response = await fetch(`${API_URL}/api/deals/${dealId}/rate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ rating }),
      });
      if (!response.ok) throw new Error('Failed to rate deal');
      return await response.json();
    } catch (error) {
      console.error('Error rating deal:', error);
      return null;
    }
  },

  // Get all deal stats
  getAllStats: async () => {
    try {
      const response = await fetch(`${API_URL}/api/deals/all-stats`);
      if (!response.ok) throw new Error('Failed to fetch all stats');
      return await response.json();
    } catch (error) {
      console.error('Error fetching all stats:', error);
      return [];
    }
  },
};


export const storeStatsApi = {
  // Get stats for a specific store
  getStats: async (storeSlug) => {
    try {
      const response = await fetch(`${API_URL}/api/stores/${storeSlug}/stats`);
      if (!response.ok) throw new Error('Failed to fetch store stats');
      return await response.json();
    } catch (error) {
      console.error('Error fetching store stats:', error);
      return null;
    }
  },

  // Rate a store (1-5 stars)
  rateStore: async (storeSlug, rating) => {
    try {
      const response = await fetch(`${API_URL}/api/stores/${storeSlug}/rate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ rating }),
      });
      if (!response.ok) throw new Error('Failed to rate store');
      return await response.json();
    } catch (error) {
      console.error('Error rating store:', error);
      return null;
    }
  },
};

export default dealStatsApi;
